import { render, staticRenderFns } from "./FiltrarElemento.vue?vue&type=template&id=27cb2ae0&"
import script from "./FiltrarElemento.vue?vue&type=script&lang=js&"
export * from "./FiltrarElemento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports